module.exports = __webpack_public_path__ + "img/IG.db28326c.png";